<template>
  <div class="reelbuzz-footer">
    <div class="content">
      <div class="list">
        <div class="meunList">
          <div class="listBt">About</div>
          <div class="title" @click="selectMenu(1)">Privacy policy</div>
          <div class="title" @click="selectMenu(2)">Terms of Service</div>
        </div>
        <div class="meunList">
          <div class="listBt">Contact</div>
          <div class="title">services@reelbuzztv.com</div>
        </div>
      </div>
      <div class="imgList">
        <img src="../assets/logo-1.png" alt="" class="logo-1" @click="changeIndex">
        <div>
          <img src="../assets/googleImg.png" alt="" @click="changeRoute(1)">
          <img src="../assets/appstoreImg.png" alt="" @click="changeRoute(2)">
        </div>
      </div>
    </div>
    <div class="trademark">
      Copyright © 2024 Reelbuzz All Rights Reserved.
    </div>
  </div>
</template>
<script>
export default {
  name: "Menu",
  data() {
    return {

    };
  },
  methods: {
    changeRoute(val) {
      if (val == 1) {
        window.location.href = "https://play.google.com/store/apps/details?id=com.reelbuzz.tv"
      } else {
        window.location.href = "https://apps.apple.com/id/app/reelbuzz/id6480157261"
      }
    },
    // changeIndex() {
    //   this.$router.push({ path: "/" });
    // },
    selectMenu(value) {
      document.documentElement.scrollTop = 0;
      switch (value) {
        case 1:
          this.$router.push({ path: "Privacy" });
          break;
        case 2:
          this.$router.push({ path: "Terms" });
          break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.reelbuzz-footer {
  width: 100%;
  padding: 30px 360px 0;
  overflow: hidden;
  box-sizing: border-box;
  background: #191A20;

  .trademark {
    padding: 26px 0;
    font-family: Lexend, Lexend;
    font-weight: 400;
    font-size: 15px;
    color: #7B7583;
    line-height: 27px;
    text-align: center;
  }

  .content {
    display: flex;
    justify-content: space-between;

    .list {
      display: flex;

      .meunList {
        margin-right: 140px;

        .listBt {
          margin-bottom: 24px;
          font-family: Lexend, Lexend;
          font-weight: 600;
          font-size: 24px;
          color: #FFFFFF;
          line-height: 28px;
        }

        .title {
          cursor: pointer;
          margin-bottom: 24px;
          font-family: Lexend, Lexend;
          font-weight: 400;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 19px;
        }
      }
    }

    .imgList {
      text-align: right;

      .logo-1 {
        cursor: pointer;
        margin-bottom: 24px;
        width: 147px;
        height: 36px;
      }

      div {
        img {
          cursor: pointer;
          margin-right: 20px;
          width: 150px;
          height: 45px;
        }

        img:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
